@if (!isLoading()) {
  <div
    class="product-preview radius-big d-flex flex-column justify-content-start
    align-items-center cursor-pointer {{ classes() }} {{ size() === 'large' ? 'large-product' : 'small-product' }}"
    (click)="handleClick()"
    [ngClass]="{ 'surface-elevated': backgroundMode() === 'elevated', 'surface-back': backgroundMode() !== 'elevated' }"
  >
    @if (product().title) {
      <div
        class="product-preview-imagebox radius-plus d-flex align-items-center justify-content-center"
        [ngClass]="{ 'surface-elevated': backgroundMode() !== 'elevated', 'surface-back': backgroundMode() === 'elevated' }"
      >
        @if (product().storeLogoImageId) {
          <daily-stores-logo-with-rate
            [backgroundMode]="backgroundMode()"
            [logoImageId]="product().storeLogoImageId"
          ></daily-stores-logo-with-rate>
        }
        <img
          class="product-preview-imagebox-img"
          src="{{ productImageSrc() }}"
          alt="{{ product().title | stripTags | cleaner | summarize: titleLimit() }}"
          (error)="handleImageError()"
        />
        <daily-stores-payment-method-badges
          [backgroundMode]="backgroundMode()"
          [paymentMethods]="product().storePaymentMethods"
        ></daily-stores-payment-method-badges>
      </div>
    }
    <div class="flex-grow d-flex flex-column w-100">
      @if (product().title || product().storeName) {
        @if (product().storeName) {
          <div class="d-flex align-items-center gap-micro l-2 text-onback-low px-tiny mb-tiny mt-small">
            <ngx-icon
              [name]="'store'"
              [iconSize]="'16px'"
            ></ngx-icon>
            <span>{{ product().storeName }}</span>
          </div>
        } @else {
          <div class="empty-16-height mb-tiny mt-small"></div>
        }
        @if (product().title) {
          <div class="product-preview-title c-2 text-onback-high w-100 px-tiny mb-minus">
            {{ product().title | stripTags | cleaner }}
          </div>
        }
      }
      @if (previousPrice() > 0 || product().price) {
        <div class="product-preview-pricebox d-flex flex-column align-items-end justify-content-center gap-atom w-100 px-tiny">
          @if (previousPrice() > 0) {
            <div class="d-flex justify-content-center align-items-center gap-tiny">
              <ngx-badge
                [mode]="'bold'"
                [status]="'error'"
                [size]="'btnBadge'"
                [template]="percentbox"
              ></ngx-badge>
              <ng-template #percentbox>
                <span class="ltr">{{ offPercent() }}</span>
              </ng-template>
              <div class="product-preview-pricebox-previous text-onback-low">{{ previousPrice() | thousands }}</div>
            </div>
          } @else {
            <div class="empty-16-height"></div>
          }
          @if (product().price) {
            <div class="d-flex align-items-center justify-content-start gap-micro">
              <div class="product-preview-pricebox-new st-6 text-onback-high">{{ product().price | thousands }}</div>
              <div class="l-4 text-onback-low">{{ priceUnit() }}</div>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <lib-ngx-skeleton-loading
    [width]="'155px'"
    [height]="'286px'"
    [classes]="'radius-plus mb-minus'"
  ></lib-ngx-skeleton-loading>
}
